<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
.table-dashboard tfoot tr td {
    background: #1f2248;
    color: #fff;
}
.new-pemungut{
    border-bottom: 1px solid #000000 !important;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page :title="title">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <!-- <z-lookup
                            label="Kod Akaun"
                            :url="service_kutipan + 'lookup/akaun_prestasi'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.akaun_id"
                        /> -->
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>KATEGORI</td>
                                <td>JUMLAH PATUT KUTIP (RM)</td>
                                <td>JUMLAH KUTIPAN SEHINGGA {{table.kutipan_title}} (RM)</td>
                                <td>BAKI KUTIPAN (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <td style="text-align: left">
                                        <inertia-link v-if="dt.lkp_hm_kegunaan_kategori_id" :href="$route('kutipan.laporan.tunggakan_mengikut_tanah')+'?lkp_hm_kegunaan_kategori_id='+dt.lkp_hm_kegunaan_kategori_id + '&tarikh_dari=' + cari.tarikh_dari + '&tarikh_hingga=' +cari.tarikh_hingga">
                                            {{ dt.kegunaan }}
                                        </inertia-link>
                                        <span v-else>
                                            {{ dt.kegunaan }}
                                        </span>
                                    </td>
                                    <td style="text-align: right">{{ dt.patut_kutip }}</td>
                                    <td style="text-align: right">{{ dt.kutipan_sebenar }}</td>
                                    <td style="text-align: right">{{ dt.baki }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="4" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><b>JUMLAH</b></td>
                                <td style="text-align: right"><b>{{table.jml_patut_kutip}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_kutipan_sebenar}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_baki}}</b></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/tunggakan_mengikut_tanah" },
                { label: "Laporan", route: "/kutipan/laporan/tunggakan_mengikut_tanah" },
                {
                    label: "Prestasi Kutipan Tunggakan Mengikut Kegunaan Tanah",
                    route: "/kutipan/laporan/tunggakan_mengikut_tanah",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", lkp_hm_kegunaan_kategori_id: "" },
            title: 'PRESTASI KUTIPAN TUNGGAKAN MENGIKUT KEGUNAAN TANAH',
        };
    },
    methods: {
        search() {
            this.getQueryData();
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", akaun_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/tunggakan_mengikut_tanah?cetak=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&lkp_hm_kegunaan_kategori_id=" + this.cari.lkp_hm_kegunaan_kategori_id,'_blank');
            },
        async getQueryData() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "kutipan/laporan/tunggakan_mengikut_tanah?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&lkp_hm_kegunaan_kategori_id=" + this.cari.lkp_hm_kegunaan_kategori_id
            );
            this.table = resp.data;
            if(this.table.kategori_title != '')
                this.title = 'PRESTASI KUTIPAN TUNGGAKAN MENGIKUT KEGUNAAN TANAH '+this.table.kategori_title;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.lkp_hm_kegunaan_kategori_id == "undefined") {
            this.cari.lkp_hm_kegunaan_kategori_id = "";
        }
        if(this.cari.lkp_hm_kegunaan_kategori_id){
            this.getQueryData()
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
